/*
 * Created on 20.05.19
 *
 * Copyright(c) 1995 - 2019 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 *
 */

export const I18N = {
    de: {
        default: 'Leider ist ein unbekannter Fehler aufgetreten.',
        // happens when browser rejects the response (for example due to cors error)
        // and no real response is received by HttpClient
        0: 'Die Anfrage kann leider nicht beantwortet werden.',
        500: 'Wir haben gegenwärtig leider Probleme unsere Server zu erreichen.',
        502: 'Wir haben gegenwärtig leider Probleme unsere Server zu erreichen.',
        503: 'Wir haben gegenwärtig leider Probleme unsere Server zu erreichen.',
        504: 'Wir haben gegenwärtig leider Probleme unsere Server zu erreichen.'
    },
    en: {
        default: 'Unfortunately, an unknown error has occurred.',
        // happens when browser rejects the response (for example due to cors error)
        // and no real response is received by HttpClient
        0: 'Unfortunately the request cannot be processed.',
        500: 'Unfortunately, we currently have problems to reach our servers.',
        502: 'Unfortunately, we currently have problems to reach our servers.',
        503: 'Unfortunately, we currently have problems to reach our servers.',
        504: 'Unfortunately, we currently have problems to reach our servers.'
    }
};
